(() => {
  if (!document.body.classList.contains('sniffcar-product-white')) return;
  // Keep the app's markup and behavior. Normalize inline !important styles so the
  // product stylesheet can control colors and mobile sizing, with desktop fallbacks.
  const mount = () => document.querySelectorAll('product-info').forEach(root => {
    if (root.sniffcarWhiteObserver) return;
    const normalize = () => root.querySelectorAll('[data-banner][data-type="product-page"]').forEach(banner => {
      if (banner.style.getPropertyValue('background') !== 'var(--sc-page-background)') {
        banner.style.setProperty('background', 'var(--sc-page-background)', 'important');
      }
      ['margin-top', 'margin-bottom'].forEach(property => {
        if (banner.style.getPropertyValue(property) !== 'var(--sc-banner-spacing, 20px)') {
          banner.style.setProperty(property, 'var(--sc-banner-spacing, 20px)', 'important');
        }
      });
      banner.querySelectorAll('[id="title"],[id="subheading"]').forEach(text => {
        if (text.style.getPropertyValue('color')) text.style.removeProperty('color');
        if (text.id === 'subheading' && text.style.getPropertyValue('font-size') !== 'var(--sc-banner-subheading-size, 14px)') {
          text.style.setProperty('font-size', 'var(--sc-banner-subheading-size, 14px)', 'important');
        }
      });
    });
    let frame;
    const observer = new MutationObserver(records => {
      if (!records.some(record => record.type === 'childList' || record.target.closest?.('[data-banner][data-type="product-page"]'))) return;
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = null; normalize(); });
    });
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    root.sniffcarWhiteObserver = observer;
    normalize();
  });
  mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('product-info:loaded', mount);
})();
